export const QUINTECH_XTREME = {
    DEFAULT_PORT: '9100',
  };
  